"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var LoginForm = function (_a) {
    var onSubmit = _a.onSubmit, onSuccess = _a.onSuccess, onError = _a.onError, errorMessage = _a.errorMessage, usernameLabel = _a.usernameLabel, passwordLabel = _a.passwordLabel;
    var _b = react_1.useState(""), username = _b[0], setUsername = _b[1];
    var _c = react_1.useState(""), password = _c[0], setPassword = _c[1];
    var _d = react_1.useState(false), loading = _d[0], setLoading = _d[1];
    var _e = react_1.useState(false), error = _e[0], setError = _e[1];
    var inputRef = react_1.useRef();
    react_1.useEffect(function () {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);
    var handleOnBlur = function () {
        setError(false);
    };
    var handleOnChange = function (setInput) { return function (e) {
        setInput(e.target.value);
        if (error) {
            setError(false);
        }
    }; };
    var handleSubmit = function (e) {
        e.preventDefault();
        setLoading(true);
        try {
            var result = onSubmit(username, password);
            if (typeof onSuccess === 'function') {
                onSuccess(result);
            }
        }
        catch (err) {
            if (typeof onError === 'function') {
                onError(err);
            }
            setError(true);
        }
        finally {
            setLoading(false);
        }
    };
    return (react_1.default.createElement(exports.LoginForm.Form, { onSubmit: handleSubmit },
        usernameLabel && (react_1.default.createElement(exports.LoginForm.Label, { htmlFor: "username", "data-qa": "username-label" }, usernameLabel)),
        react_1.default.createElement(exports.LoginForm.Input, { id: "username", type: "text", value: username, placeholder: "Username", ref: inputRef, "aria-label": "username", "data-qa": "username", onChange: handleOnChange(setUsername), onBlur: handleOnBlur }),
        passwordLabel && (react_1.default.createElement(exports.LoginForm.Label, { htmlFor: "password", "data-qa": "password-label" }, passwordLabel)),
        react_1.default.createElement(exports.LoginForm.Input, { id: "password", type: "password", value: password, placeholder: "Password", "aria-label": "password", "data-qa": "password", onChange: handleOnChange(setPassword), onBlur: handleOnBlur }),
        error && (react_1.default.createElement(exports.LoginForm.Error, { "data-qa": "error-message" }, errorMessage)),
        react_1.default.createElement(exports.LoginForm.SubmitButton, { type: "submit", value: "Log In", "data-qa": "login-button", disabled: !username || !password || loading })));
};
exports.LoginForm = LoginForm;
exports.LoginForm.Form = styled_components_1.default.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
exports.LoginForm.Label = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 12px;\n"], ["\n  margin-bottom: 12px;\n"])));
exports.LoginForm.Input = styled_components_1.default.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: none;\n  border-bottom: 1px solid black;\n  margin-bottom: 25px;\n  outline: none;\n"], ["\n  border: none;\n  border-bottom: 1px solid black;\n  margin-bottom: 25px;\n  outline: none;\n"])));
exports.LoginForm.Error = styled_components_1.default.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: red;\n  text-align: center;\n  margin: 0 0 20px;\n"], ["\n  color: red;\n  text-align: center;\n  margin: 0 0 20px;\n"])));
exports.LoginForm.SubmitButton = styled_components_1.default.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 50%;\n  margin: auto;\n  height: 30px;\n  cursor: pointer;\n  border: 1px solid black;\n  background-color: white;\n\n  :focus {\n    outline: none;\n  }\n"], ["\n  width: 50%;\n  margin: auto;\n  height: 30px;\n  cursor: pointer;\n  border: 1px solid black;\n  background-color: white;\n\n  :focus {\n    outline: none;\n  }\n"])));
exports.default = exports.LoginForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=LoginForm.js.map